module.exports = __webpack_public_path__ + "media/images/bihdr-a2b174ff32516b90601c190185429f4e.png";